<template>
    <v-row no-gutters>
        <v-col cols="auto">
            <v-btn small @click="$emit('decrement')" :disabled="lock || count == 0">-</v-btn>
            <v-btn small text class="mx-1" :disabled="!count">{{count}}</v-btn>
            <v-btn @click="$emit('increment')" :disabled="lock" small>+</v-btn>
        </v-col>
        <v-col cols="grow" style="overflow: hidden">
            <v-btn small text class="mx-4" :color="color" col="auto" :style="{opacity: count > 0 ? '100%' : '30%'}"> {{ name }} </v-btn>
        </v-col>
        <v-col cols="auto" align-self="end" align="right">
            <v-btn @click="$emit('modify')" small text icon><v-icon>more_vert</v-icon></v-btn>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: 'LessonAssignment',
    props: {
        count: {
            type: Number,
            default: 0
        },
        name: String,
        color: String,
        lock: {
            type: Boolean,
            default: false
        }
    }
};
</script>
